import { _ as _to_consumable_array } from "@swc/helpers/_/_to_consumable_array";
import { EXCLUSIVES_CATEGORY_URL_ID, NEW_BRANDS_CATEGORY_URL_ID, NEW_PRODUCTS_CATEGORY_URL_ID } from "@faire/retailer-shared/categories/urlId";
import { categoryToUrlId } from "@faire/retailer-visitor-shared/models/Category/categoryToUrlId";
import { categoryPath } from "@faire/retailer-visitor-shared/paths/category/categoryPath";
import { isNotUndefined } from "@faire/web--source/common/typescriptUtils";
/**
 * Returns the left nav category link tree for a given category
 */ export var getLeftNavLinks = function(categories, selectedCategory, routingContext) {
    var showNewLeftCategoryNavigation = selectedCategory.isNewBrandsC1 || selectedCategory.isNewProductsC1 || selectedCategory.urlId.id === EXCLUSIVES_CATEGORY_URL_ID;
    if (showNewLeftCategoryNavigation) {
        return buildLeftNavLinksForNewProductsAndNewBrands(categories, routingContext);
    } else {
        return buildLeftNavLinksForProductBasedCategory(categories, selectedCategory, routingContext);
    }
};
/*
 * Builds the left links for a product based category (any non-featured, non-new category)
 */ var buildLeftNavLinksForProductBasedCategory = function(categories, selectedCategory, routingContext) {
    var c1Category = categories.find(function(category) {
        return category.is_product_based && category.url_id === selectedCategory.urlId.id;
    });
    if (c1Category === undefined) {
        return [];
    }
    var leftNavLink = buildLeftNavLinkForCategory(c1Category, [], routingContext);
    if (leftNavLink === undefined) {
        return [];
    }
    return [
        leftNavLink
    ];
};
// Note: the New Brand + Product categories are unique from the other categories, as they
// display 2 sets of SideNav links instead of just the usual 1.
// As a result, the returned ILeftNavLink[] value will contain 2 ILeftNavLinks, instead of
// the usual 1.
var buildLeftNavLinksForNewProductsAndNewBrands = function(categories, routingContext) {
    var newBrandsCategory = categories.find(function(category) {
        return category.url_id === NEW_BRANDS_CATEGORY_URL_ID;
    });
    var newProductsCategory = categories.find(function(category) {
        return category.url_id === NEW_PRODUCTS_CATEGORY_URL_ID;
    });
    var newNavLinks = [];
    if (newBrandsCategory !== undefined) {
        var newBrandsNavLink = buildLeftNavLinkForCategory(newBrandsCategory, [], routingContext);
        var insiderCategory = getInsiderEarlyAccessCategory(categories);
        if (newBrandsNavLink && insiderCategory) {
            var insiderCategoryNavLink = buildLeftNavLinkForCategory(insiderCategory, [], routingContext);
            if (insiderCategoryNavLink) {
                newBrandsNavLink.childNavLinks.unshift(insiderCategoryNavLink);
            }
        }
        newNavLinks.push(newBrandsNavLink);
    }
    if (newProductsCategory !== undefined) {
        var _newProductsCategory_name;
        newNavLinks.push({
            name: (_newProductsCategory_name = newProductsCategory.name) !== null && _newProductsCategory_name !== void 0 ? _newProductsCategory_name : "",
            to: categoryPath({
                urlIds: [
                    {
                        id: NEW_PRODUCTS_CATEGORY_URL_ID
                    },
                    categoryToUrlId(newProductsCategory.sub_categories[0])
                ],
                routingContext: routingContext
            }),
            identifier: newProductsCategory.path_identifier,
            childNavLinks: newProductsCategory.sub_categories.map(function(category) {
                return buildLeftNavLinkForCategory(category, [
                    {
                        id: NEW_PRODUCTS_CATEGORY_URL_ID
                    }
                ], routingContext);
            }).filter(isNotUndefined)
        });
    }
    return newNavLinks.filter(isNotUndefined);
};
var buildLeftNavLinkForCategory = function(category, parentUrlIds, routingContext) {
    var _category_url_id;
    var categoryUrlId = {
        id: (_category_url_id = category.url_id) !== null && _category_url_id !== void 0 ? _category_url_id : ""
    };
    var _category_name, _category_path_identifier;
    return {
        name: (_category_name = category.name) !== null && _category_name !== void 0 ? _category_name : "",
        identifier: (_category_path_identifier = category.path_identifier) !== null && _category_path_identifier !== void 0 ? _category_path_identifier : "",
        to: categoryPath({
            urlIds: _to_consumable_array(parentUrlIds).concat([
                categoryUrlId
            ]),
            routingContext: routingContext
        }),
        childNavLinks: category.sub_categories.map(function(childCategory) {
            return buildLeftNavLinkForCategory(childCategory, _to_consumable_array(parentUrlIds).concat([
                categoryUrlId
            ]), routingContext);
        }).filter(isNotUndefined)
    };
};
var getInsiderEarlyAccessCategory = function(categories) {
    return categories.find(function(category) {
        return category.url_id === EXCLUSIVES_CATEGORY_URL_ID;
    });
};
